import { onMounted, ref, computed} from 'vue'
import { useToast } from 'primevue/usetoast'
import { toTypedSchema } from '@vee-validate/zod'
import { useForm, useFieldArray} from 'vee-validate'
import { packingListSchema, packingListSchemaForDetails } from '@/schemas/packingListSchema'
import { useRouter } from 'vue-router'
import {getPackingListById} from '@/api/packingList'
import {getOrderById} from '@/api/orders'
import {getBatchById} from "@/api/batches";


export const usePackingListForm = (formType: 'add' | 'edit' | 'view'): any => {

    const { values, handleSubmit, errors, setErrors, resetForm, meta } = useForm({
        validationSchema: toTypedSchema(packingListSchema)
    })


    const toast = useToast()
    const loading = ref(false)

    const showToast = (type: 'success' | 'error', title: string, message: string) => {
        toast.add({
            severity: type,
            summary: title,
            detail: message,
            life: 5000
        })
    }

    onMounted(async () => {
        if (formType !== 'add') {
            const packingListId = useRouter().currentRoute.value.params.id as string
            const packingList = await getPackingListById(packingListId)

            resetForm({ values: packingList })
        }
    })

    return {
        values,
        handleSubmit,
        errors,
        setErrors,
        resetForm,
        meta,
        loading,
        showToast,
        formType
    }
}

export const usePackingListDetailsForm = (formType: 'add' | 'edit' | 'view'): any => {

    const { values, handleSubmit, errors, setErrors, resetForm, meta } = useForm({
        validationSchema: toTypedSchema(packingListSchemaForDetails)
    })


    const toast = useToast()
    const loading = ref(false)

    const showToast = (type: 'success' | 'error', title: string, message: string) => {
        toast.add({
            severity: type,
            summary: title,
            detail: message,
            life: 5000
        })
    }

    const orderNumber = ref<string>('');
    const purchaseOrderReference = ref<string>('');

    onMounted(async () => {
        if (formType !== 'add') {
            const packingListId = useRouter().currentRoute.value.params.id as string
            const packingListData = await getPackingListById(packingListId)

            const orderData = packingListData.orderId
                ? await getOrderById(packingListData.orderId)
                : null;

            const batchData = packingListData.batchId
                ? await getBatchById(packingListData.batchId)
                : null;

            resetForm({ values: packingListData })

            orderNumber.value = orderData?.orderNumber || 'Order Not Found';
            purchaseOrderReference.value = batchData?.purchaseOrderReference || 'Batch Not Found';
        }
    })

    return {
        values,
        handleSubmit,
        errors,
        setErrors,
        resetForm,
        meta,
        loading,
        showToast,
        formType
    }
}